import {
  SET_TESTIMONIES,
  SET_ARTICLES,
  SET_ARTICLES_META,
  SET_ARTICLES_POPULAR,
  SET_ARTICLES_POPULAR_META,
  SET_ARTICLE_DETAIL,
  SET_MATERI,
  SET_BANNER,
  SET_BANNER_PROFILE,
  SET_BANNER_PRODUK_PEMBIAYAAN,
  SET_BANNER_SIMULASI_CICILAN,
  SET_BANNER_MITRA_MAXI,
  SET_BANNER_AXI,
  SET_BANNER_GUDANG_INFO,
  SET_BANNER_KEBIJAKAN_PRIVACY,
  SET_BANNER_MAXI_TRAVEL,
  SET_BANNER_MAXI_EDUKASI,
  SET_BANNER_MAXI_USAHA,
  SET_BANNER_MAXI_SEHAT,
  SET_BANNER_MAXI_GRIYA,
  SET_BANNER_MAXI_EXTRAGUNA,
  SET_BANNER_DANA_TUNAI_LANDSCAPE,
  SET_BANNER_DANA_TUNAI_PORTRAIT,
  SET_BANNER_MITRA_BISNIS_LANDSCAPE,
  SET_BANNER_MITRA_BISNIS_PORTRAIT,
  SET_CATEGORY_DETAIL,
} from '@/stores/constants';
import {
  getTestimonies,
  getArticles,
  getArticleBySlug,
  getArticlesPopular,
  getCategoryById,
  getBanner,
  getBannerProfile,
  getBannerProdukPembiayaan,
  getBannerSimulasiCicilan,
  getBannerMitraMaxi,
  getBannerAxi,
  getBannerGudangInfo,
  getBannerKebijakanPrivacy,
  getBannerMaxiTravel,
  getBannerMaxiEdukasi,
  getBannerMaxiUsaha,
  getBannerMaxiSehat,
  getBannerMaxiGriya,
  getBannerMaxiExtraguna,
  getBannerDanaTunaiLandscape,
  getBannerDanaTunaiPortrait,
  getBannerMitraBisnisPortrait,
  getBannerMitraBisnisLandscape,
  getMateri,
  createTestimoni,
} from '@/services/content';

export default {
  namespaced: true,
  state: {
    testimonies: [],
    articles: [],
    article: {},
    articleMeta: {},
    articlesPopular: [],
    articlePopularMeta: {},
    materi: [],
    category: {},
    categories: [],
    banner: {},
    bannerProfile: {},
    bannerProdukPembiayaan: {},
    bannerSimulasiCicilan: {},
    bannerMitraMaxi: {},
    bannerAxi: {},
    bannerGudangInfo: {},
    bannerKebijakanPrivacy: {},
    bannerMaxiTravel: {},
    bannerMaxiEdukasi: {},
    bannerMaxiUsaha: {},
    bannerMaxiSehat: {},
    bannerMaxiGriya: {},
    bannerMaxiExtraguna: {},
    bannerDanaTunaiLandscape: {},
    bannerDanaTunaiPortrait: {},
    bannerMitraBisnisLandscape: {},
    bannerMitraBisnisPortrait: {},
  },
  getters: {
    getBanner: state => state.banner,
    getBannerProfile: state => state.bannerProfile,
    getBannerProdukPembiayaan: state => state.bannerProdukPembiayaan,
    getBannerSimulasiCicilan: state => state.bannerSimulasiCicilan,
    getBannerMitraMaxi: state => state.bannerMitraMaxi,
    getBannerAxi: state => state.bannerAxi,
    getBannerGudangInfo: state => state.bannerGudangInfo,
    getBannerKebijakanPrivacy: state => state.bannerKebijakanPrivacy,
    getBannerMaxiTravel: state => state.bannerMaxiTravel,
    getBannerMaxiEdukasi: state => state.bannerMaxiEdukasi,
    getBannerMaxiUsaha: state => state.bannerMaxiUsaha,
    getBannerMaxiSehat: state => state.bannerMaxiSehat,
    getBannerMaxiGriya: state => state.bannerMaxiGriya,
    getBannerMaxiExtraguna: state => state.bannerMaxiExtraguna,
    getBannerDanaTunaiLandscape: state => state.bannerDanaTunaiLandscape,
    getBannerDanaTunaiPortrait: state => state.bannerDanaTunaiPortrait,
    getBannerMitraBisnisLandscape: state => state.bannerMitraBisnisLandscape,
    getBannerMitraBisnisPortrait: state => state.bannerMitraBisnisPortrait,
    getTestimonies: state => state.testimonies,
    getArticles: state => state.articles,
    getArticleMeta: state => state.articleMeta,
    getMateri: state => state.materi,
    getArticle: state => state.article,
    getArticlePopular: state => state.articlesPopular,
    getCategory: state => state.category
  },
  mutations: {
    [SET_TESTIMONIES](state, testimonies) {
      state.testimonies = testimonies;
    },
    [SET_ARTICLES](state, articles) {
      state.articles = articles;
    },
    [SET_ARTICLE_DETAIL](state, article) {
      state.article = article;
    },
    [SET_ARTICLES_POPULAR](state, articles) {
      state.articlesPopular = articles;
    },
    [SET_ARTICLES_POPULAR_META](state, article) {
      state.articlePopularMeta = article;
    },
    [SET_ARTICLES_META](state, meta) {
      state.articleMeta = meta;
    },
    [SET_MATERI](state, materi) {
      state.materi = materi;
    },
    [SET_CATEGORY_DETAIL](state, category) {
      state.category = category;
    },
    [SET_BANNER](state, banner) {
      state.banner = banner;
    },
    [SET_BANNER_PROFILE](state, bannerProfile) {
      state.bannerProfile = bannerProfile;
    },
    [SET_BANNER_PRODUK_PEMBIAYAAN](state, bannerProdukPembiayaan) {
      state.bannerProdukPembiayaan = bannerProdukPembiayaan;
    },
    [SET_BANNER_SIMULASI_CICILAN](state, bannerSimulasiCicilan) {
      state.bannerSimulasiCicilan = bannerSimulasiCicilan;
    },
    [SET_BANNER_MITRA_MAXI](state, bannerMitraMaxi) {
      state.bannerMitraMaxi = bannerMitraMaxi;
    },
    [SET_BANNER_AXI](state, bannerAxi) {
      state.bannerAxi = bannerAxi;
    },
    [SET_BANNER_GUDANG_INFO](state, bannerGudangInfo) {
      state.bannerGudangInfo = bannerGudangInfo;
    },
    [SET_BANNER_KEBIJAKAN_PRIVACY](state, bannerKebijakanPrivacy) {
      state.bannerKebijakanPrivacy = bannerKebijakanPrivacy;
    },
    [SET_BANNER_MAXI_TRAVEL](state, bannerMaxiTravel) {
      state.bannerMaxiTravel = bannerMaxiTravel;
    },
    [SET_BANNER_MAXI_EDUKASI](state, bannerMaxiEdukasi) {
      state.bannerMaxiEdukasi = bannerMaxiEdukasi;
    },
    [SET_BANNER_MAXI_USAHA](state, bannerMaxiUsaha) {
      state.bannerMaxiUsaha = bannerMaxiUsaha;
    },
    [SET_BANNER_MAXI_SEHAT](state, bannerMaxiSehat) {
      state.bannerMaxiSehat = bannerMaxiSehat;
    },
    [SET_BANNER_MAXI_GRIYA](state, bannerMaxiGriya) {
      state.bannerMaxiGriya = bannerMaxiGriya;
    },
    [SET_BANNER_MAXI_EXTRAGUNA](state, bannerMaxiExtraguna) {
      state.bannerMaxiExtraguna = bannerMaxiExtraguna;
    },
    [SET_BANNER_DANA_TUNAI_LANDSCAPE](state, bannerDanaTunaiLandscape) {
      state.bannerDanaTunaiLandscape = bannerDanaTunaiLandscape;
    },
    [SET_BANNER_DANA_TUNAI_PORTRAIT](state, bannerDanaTunaiPortrait) {
      state.bannerDanaTunaiPortrait = bannerDanaTunaiPortrait;
    },
    [SET_BANNER_MITRA_BISNIS_LANDSCAPE](state, bannerMitraBisnisLandscape) {
      state.bannerMitraBisnisLandscape = bannerMitraBisnisLandscape;
    },
    [SET_BANNER_MITRA_BISNIS_PORTRAIT](state, bannerMitraBisnisPortrait) {
      state.bannerMitraBisnisPortrait = bannerMitraBisnisPortrait;
    },
  },
  actions: {
    async fetchTestimonies({ commit }) {
      const result = await getTestimonies();
      const { data } = result.data;
      commit(SET_TESTIMONIES, data);
    },
    async fetchArticles({ commit }, params = { size: 15, page: 1}) {
      const result = await getArticles(params);
      const { data, meta } = result.data;
      commit(SET_ARTICLES_META, meta);
      commit(SET_ARTICLES, data);
    },
    async fetchArticlesPopular({ commit }, params = { size: 15, page: 1}) {
      const result = await getArticlesPopular(params);
      const { data, meta } = result.data;
      commit(SET_ARTICLES_META, meta);
      commit(SET_ARTICLES, data);
    },
    async fetchArticlesPopularList({ commit }, params = { size: 15, page: 1}) {
      const result = await getArticlesPopular(params);
      const { data, meta } = result.data;
      commit(SET_ARTICLES_POPULAR_META, meta);
      commit(SET_ARTICLES_POPULAR, data);
    },
    async fetchMateri({ commit }, page) {
      const result = await getMateri(page);
      const { data , meta } = result.data;
      commit(SET_MATERI, { data , meta });
    },
    async fetchBanner({ commit }) {
      const result = await getBanner();
      const { included } = result.data;
      commit(SET_BANNER, included);
    },
    async fetchBannerProfile({ commit }) {
      const result = await getBannerProfile();
      const { included } = result.data;
      commit(SET_BANNER_PROFILE, included);
    },
    async fetchBannerProdukPembiayaan({ commit }) {
      const result = await getBannerProdukPembiayaan();
      const { included } = result.data;
      commit(SET_BANNER_PRODUK_PEMBIAYAAN, included);
    },
    async fetchBannerSimulasiCicilan({ commit }) {
      const result = await getBannerSimulasiCicilan();
      const { included } = result.data;
      commit(SET_BANNER_SIMULASI_CICILAN, included);
    },
    async fetchBannerMitraMaxi({ commit }) {
      const result = await getBannerMitraMaxi();
      const { included } = result.data;
      commit(SET_BANNER_MITRA_MAXI, included);
    },
    async fetchBannerAxi({ commit }) {
      const result = await getBannerAxi();
      const { included } = result.data;
      commit(SET_BANNER_AXI, included);
    },
    async fetchBannerGudangInfo({ commit }) {
      const result = await getBannerGudangInfo();
      const { included } = result.data;
      commit(SET_BANNER_GUDANG_INFO, included);
    },
    async fetchBannerKebijakanPrivacy({ commit }) {
      const result = await getBannerKebijakanPrivacy();
      const { included } = result.data;
      commit(SET_BANNER_KEBIJAKAN_PRIVACY, included);
    },
    async fetchBannerMaxiTravel({ commit }) {
      const result = await getBannerMaxiTravel();
      const { included } = result.data;
      commit(SET_BANNER_MAXI_TRAVEL, included);
    },
    async fetchBannerMaxiEdukasi({ commit }) {
      const result = await getBannerMaxiEdukasi();
      const { included } = result.data;
      commit(SET_BANNER_MAXI_EDUKASI, included);
    },
    async fetchBannerMaxiUsaha({ commit }) {
      const result = await getBannerMaxiUsaha();
      const { included } = result.data;
      commit(SET_BANNER_MAXI_USAHA, included);
    },
    async fetchBannerMaxiSehat({ commit }) {
      const result = await getBannerMaxiSehat();
      const { included } = result.data;
      commit(SET_BANNER_MAXI_SEHAT, included);
    },
    async fetchBannerMaxiGriya({ commit }) {
      const result = await getBannerMaxiGriya();
      const { included } = result.data;
      commit(SET_BANNER_MAXI_GRIYA, included);
    },
    async fetchBannerMaxiExtraguna({ commit }) {
      const result = await getBannerMaxiExtraguna();
      const { included } = result.data;
      commit(SET_BANNER_MAXI_EXTRAGUNA, included);
    },
    async fetchBannerDanaTunaiLandscape({ commit }) {
      const result = await getBannerDanaTunaiLandscape();
      const { data } = result.data;
      commit(SET_BANNER_DANA_TUNAI_LANDSCAPE, data);
    },
    async fetchBannerDanaTunaiPortrait({ commit }) {
      const result = await getBannerDanaTunaiPortrait();
      const { data } = result.data;
      commit(SET_BANNER_DANA_TUNAI_PORTRAIT, data);
    },
    async fetchBannerMitraBisnisLandscape({ commit }) {
      const result = await getBannerMitraBisnisLandscape();
      const { data } = result.data;
      commit(SET_BANNER_MITRA_BISNIS_LANDSCAPE, data);
    },
    async fetchBannerMitraBisnisPortrait({ commit }) {
      const result = await getBannerMitraBisnisPortrait();
      const { data } = result.data;
      commit(SET_BANNER_MITRA_BISNIS_PORTRAIT, data);
    },
    async fetchArticleBySlug({ commit }, slug) {
      const result = await getArticleBySlug(slug);
      const { data } = result;
      commit(SET_ARTICLE_DETAIL, data);
    },
    async fetchCategoryById({ commit }, id) {
      const result = await getCategoryById(id);
      const { data } = result.data;
      commit(SET_CATEGORY_DETAIL, data);
    },
    // fill the empty object pattern to fix the issue.
    async createTestimoni ({commit}, payload) {
      try {
        await createTestimoni(payload);
      } catch (err) {
        throw err;
      }
    }
  },
};
